import { Component, OnInit, AfterViewInit, HostListener, Input, Output, SimpleChange, EventEmitter } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { AppService, AppSettingService, AppUtilityService } from '../app.service';
import { UserInfoService } from '../user/user-info.service';
import { TerritoryCardService, ITerritoryCard, ETerritoryCardType, ETerritoryCardLearnMoreType, ETerritoryCardDisplayMode } from '../territoryCard/territory-card.service';
import { SkillProfilerService } from '../skillProfiler/skillsMatcher/skill-profiler.service';
import { InterestSurveyResultService } from '../interestSurvey/interest-survey.service';
import { UtilityService } from '../utility/utility.service';
import { ESocialIconType } from '../socialObject/social-object.service';
import { MapService } from '../map/map.service';
import { ResourceAPIService } from '../resource/resource.service';
import Swal from 'sweetalert2';

interface IEducationDegree {
	AssociateDegreePercent: string,
	BachelorDegreePercent: string,
	DoctoralDegreePercent: string,
	HighSchoolDiplomaPercent: string,
	MasterDegreePercent: string,
	PostBaccalaureateCertificatePercent: string,
	PostDoctoralTrainingPercent: string,
	PostMasterCertificatePercent: string,
	PostSecondaryCertificatePercent: string,
	ProfessionalDegreePercent: string,
	SomeCollegeNoDegreePercent: string,
	UnderHighSchoolPercent: string
};
interface IDegree {
	degreeName: string,
	percent: string
}

@Component({
	selector: 'app-territory-card',
	templateUrl: './territory-card.component.html',
	styleUrls: ['./territory-card.scss'],
	standalone: false
})

export class TerritoryCardComponent implements OnInit {
	@Input() normalizedData: ITerritoryCard = null;
	@Input() flagFromViewAll: boolean = false;
	@Input() flagExploration: boolean = false;
	@Input() isSelf: boolean = true;
	@Input() displayMode: ETerritoryCardDisplayMode = ETerritoryCardDisplayMode.Auto;
	@Input() followStatus: string = "";
	@Input() isAvailable: boolean = false;
	@Input() forCardSelection: boolean = false;
	@Input() cardSelectionText: string = "Select";	
	@Output() onFollowToggled = new EventEmitter<any>(); // call back when user click follow icon
	@Output() onShowBackCard = new EventEmitter<ITerritoryCard>();
	@Input() onSelected: (objectId: any) => void;
	@Output() cardSelected = new EventEmitter<any>();
	tCardType = ETerritoryCardType;
	mobileView: boolean = AppSettingService.widgetMobile();
	isAnonymous: boolean = true;
	toggleAtAGlance: boolean = false;
	toggleMore: boolean = false;
	ancestorIconBackground: string = "";
	ancestorIconForeground: string = "";
	falseValue: boolean = false;
	trueValue: boolean = false;
	dataReady: boolean = false;
	forNCES: boolean = false;
	

	constructor(
		private userInfo: UserInfoService,
		private tcs: TerritoryCardService,
		public skillProfilerSrv: SkillProfilerService,
		private appSrv: AppService
	) { }

	private SetMobileView() {
		switch (this.displayMode) {
			case ETerritoryCardDisplayMode.Mobile:
				this.mobileView = true;
				break;
			case ETerritoryCardDisplayMode.Desktop:
				this.mobileView = false;
				break;
			default:
				this.mobileView = AppSettingService.widgetMobile();
				break;
		}
	}


	disableTooltip: boolean = !AppSettingService.showToolTip();
	@HostListener('window:resize', ['$event']) onResize(event: any) {
		this.SetMobileView();
		this.disableTooltip = !AppSettingService.showToolTip();
	}

	get socialObject(): any {
		return this.normalizedData.socialObject !== null ? this.normalizedData.socialObject : this.normalizedData;
	}

	onCardSelected(event: any) {
		console.log(event);
		this.cardSelected.emit(event); //send parent data about card that was selected
	}

	ngOnInit(): void {
		if (this.normalizedData.objId === "") {
			throw "objId is required for any card";
		}
		this.SetMobileView();
		this.isAnonymous = this.userInfo.isAnonymous();
		if (this.flagExploration === true) {
			this.normalizedData.TerritoryId = 1;
		}
		this.ancestorIconBackground = this.tcs.getColors(this.normalizedData.tCardType).backgroundColor;
		this.ancestorIconForeground = this.tcs.getColors(this.normalizedData.tCardType).foregroundColor;

		if (this.normalizedData.CanSocial === true) {
			if ((this.normalizedData.tCardType === ETerritoryCardType.Certification || this.normalizedData.tCardType === ETerritoryCardType.College) || ((!this.flagExploration || this.normalizedData.Depth === 4) && this.isSelf === true)) {
				this.normalizedData.CanSocial = true;
			}
			else {
				this.normalizedData.CanSocial = false;
			}
		}
		// these functions are used to call back, use bind to force "this" is itself
		this.toggleMoreBackToAtAGlance = this.toggleMoreBackToAtAGlance.bind(this);
		this.fnToggleAtAGlance = this.fnToggleAtAGlance.bind(this);
		this.dataReady = true;
		this.forNCES = this.normalizedData.tCardType === ETerritoryCardType.NCES ? true : false;
	}

	//this event is received from territoryCardMoreBack upon user clicking at-a-glance icon inside
	toggleMoreBackToAtAGlance(args: any): void {
		if (this.mobileView === true) {
			this.toggleMore = true;
		}
		else {
			this.toggleMore = false;
		}
		this.toggleAtAGlance = true;
		this.showBackCard();
	}

	fnToggleAtAGlanceMobile(args: any): void {
		// if we do not have at glance, show action
		if (!this.normalizedData.hasAtAGlance) {
			return;
		}
		this.toggleMore = true;
		if (this.toggleAtAGlance === true) {
			this.toggleAtAGlance = false;
			this.toggleMore = false;
		}
		else {
			this.toggleAtAGlance = true;
		}
		this.showBackCard();
	}

	closeBackCard(): void {
		this.toggleAtAGlance = false;
		this.toggleMore = false;
	}

	fnToggleAtAGlance(args: any): void {
		this.toggleMore = false;
		this.toggleAtAGlance = !this.toggleAtAGlance;
		this.showBackCard();
	}

	fnToggleMore(): void {
		this.toggleAtAGlance = false;
		this.toggleMore = !this.toggleMore;
		this.showBackCard();
	}

	followToggled(args: any): void {
		this.onFollowToggled.emit(args);
	};

	showBackCard(): void {
		if (this.toggleAtAGlance || this.toggleMore) {
			if (this.onShowBackCard != null) {
				this.onShowBackCard.emit(this.normalizedData);
			}
		}
	}

	forNcesSelectSchool() {
		// if this is from search, we need to redirect to api to change the landing page
		if (window.location.pathname.toLowerCase().indexOf(AppSettingService.baseUrl.toLowerCase()) === 0) {
			window.location.href = "/Search/NCES/" + this.normalizedData.objId;
		}
		else {
			this.appSrv.redirectReload("/NCES/School/" + this.normalizedData.objId);
		}
	}

	maskCard: boolean = false;
	disableCard(mask: boolean) {
		// switch to the front end card
		if (this.toggleMore) {
			this.fnToggleMore();
		}
		this.maskCard = mask;
	}
}


@Component({
	selector: 'app-territory-card-splash',
	templateUrl: './territory-card-splash.component.html',
	styleUrls: ['./territory-card.scss'],
	standalone: false
})
export class TerritoryCardSplashComponent implements OnInit, AfterViewInit {
	@Input() normalizedData: ITerritoryCard;
	@Input() flagExploration: boolean;
	@Input() isSelf: boolean;
	@Input() followStatus: any;
	@Input() forCardSelection: boolean = false;
	@Output() onFollowToggled = new EventEmitter<any>(); // call back when user click follow icon

	tCardType = ETerritoryCardType;
	isAnonymous: boolean = true;
	toggleAtAGlance: boolean = false;
	ancestorIconBackground: string;
	ancestorIconForeground: string;
	imageType: number = 1;

	constructor(
		private userInfo: UserInfoService,
		private tcs: TerritoryCardService
	) { }

	disableTooltip: boolean = !AppSettingService.showToolTip();
	iconContainerWidth: number = 0;
	@HostListener('window:resize', ['$event']) onResize(event: any) {
		setTimeout(() => {
			if (document.getElementById('splashIconContainer')) {
				this.iconContainerWidth = document.getElementById('splashIconContainer').clientWidth;
			}
		}, 250);

		this.disableTooltip = !AppSettingService.showToolTip();
	}

	get socialObject(): any {
		return this.normalizedData.socialObject !== null ? this.normalizedData.socialObject : this.normalizedData;
	}

	ngAfterViewInit() {
		setTimeout(() => {
			if (document.getElementById('splashIconContainer')) {
				this.iconContainerWidth = document.getElementById('splashIconContainer').clientWidth;
			}
		}, 0);
	}

	ngOnInit(): void {
		this.isAnonymous = this.userInfo.isAnonymous();
		this.ancestorIconBackground = this.tcs.getColors(this.normalizedData.tCardType).backgroundColor;
		this.ancestorIconForeground = this.tcs.getColors(this.normalizedData.tCardType).foregroundColor;
		if (this.normalizedData.CanSocial === true) {
			if ((this.normalizedData.tCardType === ETerritoryCardType.Certification || this.normalizedData.tCardType === ETerritoryCardType.College) || ((!this.flagExploration || this.normalizedData.Depth === 4) && this.isSelf === true)) {
				this.normalizedData.CanSocial = true;
			}
			else {
				this.normalizedData.CanSocial = false;
			}
		}

		switch (this.normalizedData.tCardType) {
			case ETerritoryCardType.Training:
				// the image ratio is dynamic
				this.imageType = 5;
				break;
			case ETerritoryCardType.Resource:
				// the image ratio is dynamic
				this.imageType = 4;
				break;
			case ETerritoryCardType.Podcast:
			case ETerritoryCardType.PodcastEpisode:
				// the image ratio is 1x1
				this.imageType = 3;
				break;
			case ETerritoryCardType.Institution:
				// the image ratio is 1x1 but mostly is logo
				this.imageType = 2;
				break;
			case ETerritoryCardType.Folder:
				// no image for folder (template will show whatever instead)
				this.imageType = 0;
				break;
			case ETerritoryCardType.Military:
				// the image ratio 482x342
				this.imageType = 6;
				break;
			default:
				// the image ratio is 2x1
				this.imageType = 1;
				break;
		}
	}

	followToggled(args: any): void {
		this.onFollowToggled.emit(args);
	};
}

@Component({
	selector: 'app-territory-card-action-bar',
	templateUrl: './territory-card-action-bar.component.html',
	styleUrls: ['./territory-card.scss'],
	standalone: false
})
export class TerritoryCardActionBarComponent implements OnInit {
	@Input() normalizedData: ITerritoryCard;
	@Input() flagExploration: boolean;
	@Input() isSelf: boolean;
	@Input() onSelected: (objectId: any) => void;
	@Input() doToggleAtAGlance: (args: any) => void; // call back when user click follow icon
	@Input() cardSelectionText: string = "Select";
	@Input() forCardSelection: boolean = false; //turns the actionbar into a selection button triggering onSelection() which triggers output event selected.
	@Output() cardSelected = new EventEmitter<any>();

	tCardType = ETerritoryCardType;
	tLearnMoreType = ETerritoryCardLearnMoreType;
	mobileView: boolean = AppSettingService.widgetMobile();
	isAnonymous: boolean = true;
	learnMoreTooltip: string = "";
	actionLearnMoreClickTrigger: boolean = false;
	actionMapClickTrigger: boolean = false;
	actionJourneyClickTrigger: boolean = false;
	actionSelectClickTrigger: boolean = false;
	actionCareerOneStopVideoClickTrigger: boolean = false;
	
	constructor(
		private router: Router,
		private userInfo: UserInfoService,
	) { }

	disableTooltip: boolean = !AppSettingService.showToolTip();
	@HostListener('window:resize', ['$event']) onResize(event: any) {
		this.mobileView = AppSettingService.widgetMobile();
		this.disableTooltip = !AppSettingService.showToolTip();
		this.updateTooltip();
	}

	onCardSelection(event: any) {
		this.cardSelected.emit(this.normalizedData);
	}

	private updateTooltip(): void {
		switch (this.normalizedData.learnMoreType) {
			case ETerritoryCardLearnMoreType.Audio:
				this.learnMoreTooltip = "Listen";
				break;
			case ETerritoryCardLearnMoreType.PodcastEpisode:
				this.learnMoreTooltip = "View Episodes";
				break;
			default:
				this.learnMoreTooltip = "Learn More";
				break;
		}
	}

	ngOnInit(): void {
		this.isAnonymous = this.userInfo.isAnonymous();
		this.updateTooltip();
	}

	selectCareer(): void {
		if (this.onSelected != null) {
			if (this.normalizedData.Depth < 4) {
				//this gets called when user selects cluster or pathway card from Career Exploration:
				//onSelected(...) is callback function passed from Career Explore component
				this.onSelected({ careerId: this.normalizedData.MapObjectId, careerName: this.normalizedData.Name });
			}
			else {
				//this gets called when user selects occupation from Career Exploration
				this.router.navigateByUrl("Career/LearnMore/" + this.normalizedData.MapObjectId);
			}
		}
	}

	clickToggleAtAGlance(args: any): void {
		if (this.doToggleAtAGlance) {
			this.doToggleAtAGlance(args);
		}
	}

	//generic event handler for buttons on cards instead of action bar icons
	//(might consider wiring this to an event emit that can be read by our object-carousel component or from whereever else...)
	onButtonSelect() {
		if (this.normalizedData.tCardType === this.tCardType.ProfessionalAssociation) {
			window.open(this.normalizedData.externalUrl, "_blank");
		}
	}
}



@Component({
	selector: 'app-territory-card-at-a-glance',
	templateUrl: './territory-card-at-a-glance.component.html',
	styleUrls: ['./territory-card.scss'],
	standalone: false
})
export class TerritoryCardAtAGlanceComponent implements OnInit {
	@Input() normalizedData: ITerritoryCard;
	@Input() forMobile: boolean = false;

	tCardType = ETerritoryCardType;
	constructor(
		private utilitySrv: UtilityService
	) { }

	//need the "name" value from response for this to work
	getGrowthDisplay(): any {
		return MapService.convertProjectedGrowth(this.normalizedData.ProjectedEmploymentGrowthAverage);
	}

	formatFraction(val: any): void {
		if (!isNaN(val)) {
			if (typeof val !== 'string') {
				val = val.toString();
			}
			return val.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
		}
		return val;
	}

	sortedDegrees: IDegree[] = [];

	sortDegrees(): void {
		let degrees: any[] = [];
		let educationKeys = Object.keys(this.normalizedData.Education);
		for (let i = 0; i < educationKeys.length; i++) {
			degrees.push({ degreeName: educationKeys[i], percent: this.normalizedData.Education[educationKeys[i]] });
		}
		degrees.sort((a: any, b: any) => { return a.percent > b.percent ? -1 : 1; });
		this.sortedDegrees = degrees;
	};

	hasDegreeData: boolean = false;
	degreeName: any = null;
	degreePercent: any = null;
	educationDegreeKeyToString: IEducationDegree = {
		AssociateDegreePercent: 'Associate\'s degree',
		BachelorDegreePercent: 'College (4 Year)',
		DoctoralDegreePercent: 'Doctoral degree',
		HighSchoolDiplomaPercent: 'High school',
		MasterDegreePercent: 'Master\'s degree',
		PostBaccalaureateCertificatePercent: 'Post-baccalaureate certificate',
		PostDoctoralTrainingPercent: 'Post-baccalaureate certificate',
		PostMasterCertificatePercent: 'Post-master certificate',
		PostSecondaryCertificatePercent: 'Professional degree certificate',
		ProfessionalDegreePercent: 'Professional degree',
		SomeCollegeNoDegreePercent: 'Some college',
		UnderHighSchoolPercent: 'No high school diploma'
	};

	getEducationDegree(key: string): string {
		return this.educationDegreeKeyToString[key as keyof typeof this.educationDegreeKeyToString];
	}

	toCommaNumber(val: any) {
		var formattedVal = AppUtilityService.toCommaNumber(val);
		return formattedVal === "" ? "N/A" : formattedVal;
	}

	convertToPercent(val: string): string {
		var formattedVal = AppUtilityService.toPercent(val, 0);
		return formattedVal === "" ? "N/A" : formattedVal + '%';
	};

	toDollar(v: string) {
		return AppUtilityService.toDollar(v, true);
	}

	showCIPDetail(): void {
		if ((this.normalizedData.CIPCode ?? "").trim() !== "") {
			let code = this.normalizedData.CIPCode.trim();
			let title = `CIP Code: ${code}`;
			let desc = `For more information on CIP Codes please click <a href='https://nces.ed.gov/ipeds/cipcode/cipdetail.aspx?y=56&cip=${code}' target='_blank' style='color:blue; text-decoration:underline;'>here</a>.`;
			this.utilitySrv.openReadMoreDialog(title, desc, "");
		}
	}

	ngOnInit(): void {
		if (this.normalizedData.Education !== undefined && this.normalizedData.Education !== null) {
			this.sortDegrees();
			for (var i = 0; i < this.sortedDegrees.length; i++) {
				if (parseFloat(this.sortedDegrees[i].percent) > 0) {
					this.hasDegreeData = true;
				}
			}
		}
	};
}


@Component({
	selector: 'app-territory-card-fit-status',
	templateUrl: './territory-card-fit-status.component.html',
	styleUrls: ['./territory-card.scss'],
	standalone: false
})
export class TerritoryCardFitStatusComponent implements OnInit {
	@Input() normalizedData: ITerritoryCard;
	@Input() flagFromViewAll: boolean;
	@Input() flagExploration: boolean = false;
	skillFit: boolean = false;
	skillScore: number = 0;
	interestFit: boolean = false;
	interestScore: number = 0;

	constructor(
		private skillProfilerSrv: SkillProfilerService,
		private interestSurveyResult: InterestSurveyResultService
	) { }

	ngOnInit(): void {
		if (this.normalizedData.tCardType !== ETerritoryCardType.Career) {
			return;
		}

		if (this.flagExploration && this.normalizedData.FitScoreSkill != null) {
			if (this.normalizedData.FitScoreSkill > 0) {
				this.skillScore = this.normalizedData.FitScoreSkill;
			}
		}
		else {
			this.skillScore = this.skillProfilerSrv.getSkillFit(this.normalizedData.OccupationCode);
		}
		this.skillFit = (this.skillScore > 0 && this.skillScore < 4) ? true : false;


		if (this.flagExploration && this.normalizedData.FitScoreInterest != null) {
			if (this.normalizedData.FitScoreInterest > 0) {
				this.interestScore = this.normalizedData.FitScoreInterest;
			}
		}
		else {
			this.interestScore = this.interestSurveyResult.getInterestFit(this.normalizedData.OccupationCode);
		}
		this.interestFit = (this.interestScore > 0 && this.interestScore < 4) ? true : false;
	}
}


@Component({
	selector: 'app-territory-card-more',
	templateUrl: './territory-card-more.component.html',
	styleUrls: ['./territory-card.scss'],
	standalone: false
})
export class TerritoryCardMoreComponent implements OnInit {
	@Input() normalizedData: ITerritoryCard;
	@Input() forMobile: boolean;
	@Input() flagExploration: boolean;
	@Input() isSelf: boolean;
	@Input() followStatus: any;
	@Input() mobileView: boolean = AppSettingService.widgetMobile();
	@Output() onFollowToggled = new EventEmitter<any>(); // call back when user click follow icon
	@Input() onAtAGlanceToggled: (args: any) => void;
	@Output() onDisableCard = new EventEmitter<boolean>();
	
	tCardType = ETerritoryCardType;
	tLearnMoreType = ETerritoryCardLearnMoreType;
	tSocialIconType = ESocialIconType;
	actionCareerOneStopVideoClickTrigger: boolean = false;


	//todo: see if we can get these name values from an api call, but for now just hardcode
	roleNames: any = {
		1: 'Administrator',
		2: 'Administrator',
		3: 'Administrator',
		4: 'Teacher',
		5: 'Student',
		7: 'Board',
		8: 'Parent',
		9: 'Staff',
		10: 'Staff',
		11: 'Counselor',
		201: 'Other',
		254: 'Administrator',
		255: 'Anonymous'
	}
	constructor(
		private resourceAPI: ResourceAPIService,
		private userInfoService: UserInfoService
	) { }

	currentUserPersonId: string = null;

	ngOnInit(): void {
		this.currentUserPersonId = this.userInfoService.getProfile().PersonId;	
	}

	get socialObject(): any {
		return this.normalizedData.socialObject !== null ? this.normalizedData.socialObject : this.normalizedData;
	}

	followClick(): void {
		this.actionFollowClickTrigger = !this.actionFollowClickTrigger;
	}

	actionSelectClickTrigger: boolean = false;
	selectClick(): void {
		this.actionSelectClickTrigger = !this.actionSelectClickTrigger;
	}

	actionLearnMoreClickTrigger: boolean = false;
	learnMoreClick(): void {
		this.actionLearnMoreClickTrigger = !this.actionLearnMoreClickTrigger;
	}

	actionMapClickTrigger: boolean = false;
	actionJourneyClickTrigger: boolean = false;

	atAGlanceClick(): void {
		if (this.onAtAGlanceToggled != null) {
			this.onAtAGlanceToggled(null);
		}
	};

	actionFollowClickTrigger: boolean = false;
	followToggled(args: any): void {
		this.onFollowToggled.emit(args);
	};

	onLinkClick(normalizedData: any) {
		if (this.normalizedData.tCardType === this.tCardType.ProfessionalAssociation) {
			window.open(this.normalizedData.externalUrl, "_blank");
		}
	}

	private updateResourceShare(share: boolean) {
		this.resourceAPI.updateUserResourceShare(this.normalizedData.objId, share).subscribe({
			next: (response) => {
				this.normalizedData.AtAGlance_Resource.Share = share;
			},
			error: (err) => {
				//rollback change
				this.normalizedData.AtAGlance_Resource.Share = !share;
				console.log(err);
				let msg: string = "Fail to update, please retry";
				if (err != null && err.error != null && err.error.Detail != null) {
					msg = "Fail to update. " + err.error.Detail;
				}
				Swal.fire({ title: "Oops", text: msg, icon: "error" });
			}
		});
	}

	toggleResourceShare(e: any, share: boolean) {
		e.preventDefault();
		if (share == false) {
			Swal.fire({
				title: "Confirm Share Change!",
				html: "<div class='pt-4 fw-bold border-top'>Are you sure you want to stop sharing this resource?</div><div class= 'mt-2 pb-4 border-bottom' style='color:#0d6efd'>When a resource is un-shared, system will permanently remove all follows to this resource.</div>",
				icon: "warning",
				showCancelButton: true,
				cancelButtonText: "Cancel",
				confirmButtonText: "Stop Sharing",
				reverseButtons: true
			}).then((choice: any) => {
				if (choice.isConfirmed) {
					this.updateResourceShare(share);
				}
				else {
					e.target.checked = false;
					this.normalizedData.AtAGlance_Resource.Share = true;
					var rads = document.getElementById("rdShareResourceTrue" + this.normalizedData.objId) as HTMLInputElement;
					rads.checked = true;
				}
			});
		}
		else {
			this.updateResourceShare(share);
		}
	}

	toggleResourcePriority(e: Event, priority: boolean) {
		e.preventDefault();
		this.resourceAPI.updateUserResourcePriority(this.normalizedData.objId, priority).subscribe({
			next: (response) => {
				this.normalizedData.AtAGlance_Resource.Priority = priority;
			},
			error: (err) => {
				// roll back change
				this.normalizedData.AtAGlance_Resource.Share = !priority;
				console.log(err);
				let msg: string = "Fail to update, please retry";
				if (err != null && err.error != null && err.error.Detail != null) {
					msg = "Fail to update. " + err.error.Detail;
				}
				Swal.fire({ title: "Oops", text: msg, icon: "error" });
			}
		});
	}

	deletingResource: boolean = false;
	deleteResource() {
		Swal.fire({
			title: "Confirm Deletion!",
			html: "<div class='pt-4 fw-bold border-top'>Are you sure you want to delete this resource?</div><div class='mt-2 pb-4 border-bottom' style='color:#0d6efd'>This action cannot be undone, and the resource will be permanently removed from your uploads.</div>",
			icon: "warning",
			showCancelButton: true,
			cancelButtonText: "Cancel",
			confirmButtonText: "Delete",
			reverseButtons: true
		}).then((choice: any) => {
			if (choice.isConfirmed) {
				this.deletingResource = true;
				this.resourceAPI.deleteUserResource(this.normalizedData.objId).subscribe({
					next: (response) => {
						this.onDisableCard.emit(true);
					},
					error: (err) => {
						console.log(err);
						let msg: string = "Fail to delete, please retry";
						if (err != null && err.error != null && err.error.Detail != null) {
							msg = "Fail to delete. " + err.error.Detail;
						}
						Swal.fire({ title: "Oops", text: msg, icon: "error" });
					}
				});
			}
		});
	}

	learnMoreResource() {
		if (this.normalizedData.externalUrl != null && this.normalizedData.externalUrl !== "") {
			window.open(this.normalizedData.externalUrl, "_blank");
		}
	}
}



@Component({
	selector: 'app-action-learn-more',
	templateUrl: './action-learn-more.component.html',
	standalone: false
})
export class ActionLearnMoreComponent implements OnInit {
	@Input() clicked: boolean = false;
	@Input() normalizedData: ITerritoryCard;

	constructor(
		private tcs: TerritoryCardService,
		private router: Router,
		private location: Location,
		private utilitySrv: UtilityService
	) { }

	tLearnMoreType = ETerritoryCardLearnMoreType;
	tCardType = ETerritoryCardType;

	ngOnInit(): void { }

	ngOnChanges(changes: { [propertyName: string]: SimpleChange }) {
		if (changes['clicked']) {
			let clicked = changes['clicked'];
			if ((clicked.previousValue ?? null) != null && (clicked.currentValue ?? null) != null && clicked.currentValue != clicked.previousValue) {
				if (this.normalizedData.disableLearnMore) {
					if (this.normalizedData.tCardType === ETerritoryCardType.CSCDegree) {
						this.utilitySrv.openReadMoreDialog("&nbsp;", "<b>We are still gathering information about this degree!</b>", "");
					}
					else {
						this.utilitySrv.openReadMoreDialog("&nbsp;", "<b>We are still gathering information about this object!</b>", "");
					}
				}
				else {
					if (this.normalizedData.tCardType === ETerritoryCardType.Institution) {
						this.router.navigateByUrl("CollegeScorecard/School/" + this.normalizedData.objId);
					}
					else if (this.normalizedData.tCardType === ETerritoryCardType.Podcast) {
						// do not reload page but just change url
						this.location.replaceState("Cyber/Podcast/" + this.normalizedData.objId);
					}
					else if (this.normalizedData.externalUrl != null && this.normalizedData.externalUrl !== "") {
						window.open(this.normalizedData.externalUrl, "_blank");
					}
					else if (this.normalizedData.MapObjectId !== "") {
						this.tcs.go(this.normalizedData.MapObjectId);
					}
				}
			}
		}
	}
}
